module["exports"] = [
  "/3528-####-####-###L/",
  "/3529-####-####-###L/",
  "/35[3-8]#-####-####-###L/"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/credit_card/jcb.js
// module id = 867
// module chunks = 0